import { render } from "./EtatPaiementPage.vue?vue&type=template&id=54bb0859&ts=true"
import script from "./EtatPaiementPage.vue?vue&type=script&lang=ts"
export * from "./EtatPaiementPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__